import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, Observable, of } from 'rxjs';
import { User } from '../models/user';
import { BaseService } from './base.service';
import { JwtHelperService } from '@auth0/angular-jwt';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  baseUrl = this.base.apiUrl + 'auth/';
  token: string;
  jwtHelper = new JwtHelperService();
  userToken: any;
  decodedToken: any;

  public currentUserSubject: BehaviorSubject<User | null>;
  public currentUser: Observable<User | null>;
  public user: User | null;

  constructor(
    private http: HttpClient,
    public router: Router,
    private base: BaseService
  ) {
    const savedUser = this.getSavedUser();

    this.currentUserSubject = new BehaviorSubject<User | null>(savedUser);
    this.currentUser = this.currentUserSubject.asObservable();
    this.user = savedUser;
  }

  public get currentUserValue(): User | null {
    return this.currentUserSubject.value;
  }

  private getSavedUser(): User | null {
    const user = localStorage.getItem('user');

    if (!user || user === 'undefined' || user === 'null') {
      localStorage.removeItem('user');
      return null;
    }

    try {
      return JSON.parse(user);
    } catch {
      localStorage.removeItem('user');
      return null;
    }
  }

  login(model: any) {
    return this.http.post(this.baseUrl + 'login', model);
  }

  autoLoginByCompanyAndUser(model: { companyId: number; userId: number }) {
    return this.http.post(this.baseUrl + 'AutoLoginByCompanyAndUser', model);
  }

  logout() {
    localStorage.removeItem('user');
    localStorage.removeItem('token');
    localStorage.clear();

    this.currentUserSubject.next(null);
    this.user = null;

    this.router.routeReuseStrategy.shouldReuseRoute = () => false;
    this.router.navigate(['/auth/login']);

    return of({ success: false });
  }

  get isLoggedIn(): boolean {
    const token = localStorage.getItem('token');

    return !!token && !this.jwtHelper.isTokenExpired(token);
  }

  isAuthenticated() {
    const token = localStorage.getItem('token');

    if (!token || token === 'undefined' || token === 'null') {
      return false;
    }

    return !this.jwtHelper.isTokenExpired(token);
  }
}